import { makeStyles, shorthands } from '@fluentui/react-components';

const parentShared = {
  height: '20px',
  width: '20px',
  ...shorthands.borderRadius('50%'),
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
};

export const useStyles = makeStyles({
  parentActive: {
    ...parentShared,
    backgroundColor: '#dff6dd',
  },
  parentPending: {
    ...parentShared,
    backgroundColor: '#EFF6FC',
  },
  parentWarning: {
    ...parentShared,
    backgroundColor: '#FFF4CE',
  },
  parentError: {
    ...parentShared,
    backgroundColor: '#FDE7E9',
  },
  childActive: {
    color: '#107C10',
  },
  childPending: {
    color: '#004578',
  },
  childWarning: {
    color: '#D83B01',
  },
  childError: {
    color: '#A80000',
  },
});
